import { usePageTitle } from "../hooks/usePageTitle";
import Footer from "../components/Footer";
import CompanyOverviewSection from "../components/AboutUsSection/CompanyOverviewSection";
import PurposeSection from "../components/AboutUsSection/PurposeSection";
import WhyChoosePaladinSection from "../components/AboutUsSection/WhyChoosePaladinSection";
import TeamSection from "../components/AboutUsSection/TeamSection";
import PartnershipsSection from "../components/AboutUsSection/PartnershipsSection";
import AboutUsCtaSection from "../components/AboutUsSection/AboutUsCtaSection";
import FindUsSection from "../components/HomepageSection/FindUsSection";

export default function AboutUsPage() {
  usePageTitle("Why Paladin");
  return (
    <div className="min-h-screen bg-white-pure text-black-deep">
      <main>
        <CompanyOverviewSection />
        <PurposeSection />
        <WhyChoosePaladinSection />
        <TeamSection />
        <PartnershipsSection />
        <FindUsSection />
        <AboutUsCtaSection />
      </main>
      <footer><Footer /></footer>
    </div>
  );
}